module.exports = {"npc_death":"Mort de l'ennemi","player_death":"Mort du joueur","player_spell":"Lancer de Soif de sang"};